var React = require('react');

function IconPyramid (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("path",{"d":"M34.5793,29.7443 L17.9923,1.0143 C17.7593,0.6103 17.0953,0.6103 16.8613,1.0143 L0.1953,29.8813 C0.0793,30.0823 0.0793,30.3313 0.1953,30.5333 C0.3123,30.7353 0.5273,30.8603 0.7613,30.8603 L34.0933,30.8603 C34.1013,30.8593 34.1093,30.8583 34.1193,30.8603 C34.4793,30.8603 34.7723,30.5683 34.7723,30.2073 C34.7723,30.0263 34.6983,29.8633 34.5793,29.7443 L34.5793,29.7443 Z M27.9563,20.8843 L6.8973,20.8843 L11.1493,13.5193 L23.7043,13.5193 L27.9563,20.8843 Z M17.4273,2.6463 L22.9503,12.2143 L11.9033,12.2143 L17.4273,2.6463 Z M1.8923,29.5543 L6.1443,22.1893 L28.7103,22.1893 L32.9623,29.5543 L1.8923,29.5543 Z","id":"Fill-1","fill":"#020093"})));
}

IconPyramid.defaultProps = {"width":"35px","height":"31px","viewBox":"0 0 35 31"};

module.exports = IconPyramid;

IconPyramid.default = IconPyramid;
